import { forwardRef } from 'react';
import { StyledUl } from './styled';

const Ul = forwardRef((props, ref) => <StyledUl ref={ref} {...props} />);

export default Ul;
